import React from 'react';
import moment from 'moment';
import { ConversationSummary } from '../../types/IAiConversation';
import PlusIcon from '../icons/PlusIcon';
import TrashIcon from '../icons/TrashIcon';

interface IProps {
  conversations: ConversationSummary[];
  selectedId: number | null;
  isLoading: boolean;
  disabled: boolean;
  open: boolean;
  onClose: () => void;
  onSelect: (id: number) => void;
  onDelete: (id: number) => void;
  onNew: () => void;
}

export const titleOf = (c: ConversationSummary) =>
  c.title?.trim() || 'New conversation';

// The person's saved conversations. A column beside the chat on wide screens, an off-canvas
// panel (open/onClose) under 980 px.
const ConversationList = ({
  conversations,
  selectedId,
  isLoading,
  disabled,
  open,
  onClose,
  onSelect,
  onDelete,
  onNew,
}: IProps) => (
  <>
    {open ? (
      <div
        className="chat-list-backdrop"
        role="presentation"
        onClick={onClose}
        data-testid="chat-list-backdrop"
      />
    ) : null}
    <aside
      className={`chat-list${open ? ' chat-list--open' : ''}`}
      aria-label="Conversations"
    >
      <div className="chat-list-head">
        <b>Conversations</b>
        <button
          type="button"
          className="btn-app btn-app--primary btn-app--sm"
          onClick={onNew}
          disabled={disabled}
          data-track="ai_new_conversation"
        >
          <PlusIcon />
          New
        </button>
      </div>
      <div className="chat-list-items">
        {conversations.map((c) => {
          const title = titleOf(c);
          const meta = `${moment.utc(c.dateUpdated).fromNow()} · ${
            c.messageCount
          } message${c.messageCount === 1 ? '' : 's'}`;
          return (
            <div
              key={c.id}
              className={`chat-list-item${
                c.id === selectedId ? ' chat-list-item--active' : ''
              }`}
            >
              <button
                type="button"
                className="chat-list-item-open"
                onClick={() => onSelect(c.id)}
                disabled={disabled}
                data-track="ai_conversation_opened"
                data-track-id={c.id}
              >
                <span className="chat-list-item-title">{title}</span>
                <span className="chat-list-item-meta">{meta}</span>
              </button>
              <button
                type="button"
                className="icon-btn icon-btn--danger chat-list-item-delete"
                aria-label={`Delete ${title}`}
                title="Delete"
                onClick={() => onDelete(c.id)}
                disabled={disabled}
                data-track="ai_conversation_deleted"
              >
                <TrashIcon />
              </button>
            </div>
          );
        })}
        {!isLoading && conversations.length === 0 ? (
          <div className="chat-list-empty">No conversations yet.</div>
        ) : null}
      </div>
    </aside>
  </>
);

export default ConversationList;
